export const M2_UNIT_12 = {
  id: "m2-u12",
  title: "Unit 12: Have / Has",
  topic: "Possession",
  iconType: "box", // Usamos 'box' porque hablamos de tener objetos
  grammarImage: "/m2-u12-grammar.jpg", // Recuerda subir esta imagen a public
  grammarText: "Usamos 'Have' para I/You/We/They y 'Has' para He/She/It. Para negar usamos 'Don't have' o 'Doesn't have'.",
  sets: [
    {
      id: "u28-set1",
      title: "Set 1: Have/Has - Basic Affirmative",
      questions: [
        { type: "mc", q: "I ___ a garage.", options: ["have", "has"], a: "have" },
        { type: "mc", q: "She ___ a yard.", options: ["have", "has"], a: "has" },
        { type: "blank", q: "They ___ a car. (have)", options: ["have"], a: "have" },
        { type: "mc", q: "He ___ a house.", options: ["have", "has"], a: "has" },
        { type: "blank", q: "You ___ a chair. (have)", options: ["have"], a: "have" },
        { type: "order", q: "Ordena: We have a door.", words: ["We", "have", "a", "door."], a: "We have a door." },
        { type: "mc", q: "'It has a daughter.' 3rd person = True.", options: ["True", "False"], a: "True" },
        { type: "mc", q: "They ___ a dog.", options: ["have", "has"], a: "have" },
        { type: "blank", q: "It ___ a door. (has)", options: ["has"], a: "has" },
        { type: "order", q: "Ordena: He has a house.", words: ["He", "has", "a", "house."], a: "He has a house." }
      ]
    },
    {
      id: "u28-set2",
      title: "Set 2: Have/Has Chart Practice",
      questions: [
        { type: "mc", q: "I, you, we, they → ___", options: ["have", "has"], a: "have" },
        { type: "mc", q: "He, she, it → ___", options: ["has", "have"], a: "has" },
        { type: "blank", q: "You ___ a house. (have)", options: ["have"], a: "have" },
        { type: "mc", q: "She ___ a dog.", options: ["has", "have"], a: "has" },
        { type: "blank", q: "We ___ a car. (have)", options: ["have"], a: "have" },
        { type: "order", q: "Ordena: They have a chair.", words: ["They", "have", "a", "chair."], a: "They have a chair." },
        { type: "mc", q: "'I has' wrong = True.", options: ["True", "False"], a: "True" },
        { type: "mc", q: "It ___ a daughter.", options: ["has", "have"], a: "has" },
        { type: "blank", q: "He ___ a garage. (has)", options: ["has"], a: "has" },
        { type: "order", q: "Ordena: You have a house.", words: ["You", "have", "a", "house."], a: "You have a house." }
      ]
    },
    {
      id: "u28-set3",
      title: "Set 3: Have Negatives",
      questions: [
        { type: "mc", q: "I do not ___ a car. = I don't ___ a car.", options: ["have", "has"], a: "have" },
        { type: "mc", q: "She does not ___ a church. = She doesn't ___", options: ["have", "has"], a: "have" },
        { type: "blank", q: "I ___ have a car. (don't)", options: ["don't"], a: "don't" },
        { type: "mc", q: "Greendale doesn't ___ a church.", options: ["have", "has"], a: "have" },
        { type: "blank", q: "They ___ have a garage. (don't)", options: ["don't"], a: "don't" },
        { type: "order", q: "Ordena: Kaleh doesn't have a dog.", words: ["Kaleh", "doesn't", "have", "a", "dog."], a: "Kaleh doesn't have a dog." },
        { type: "mc", q: "'She doesn't has' wrong = True.", options: ["True", "False"], a: "True" },
        { type: "mc", q: "You do not ___ a microwave.", options: ["have", "has"], a: "have" },
        { type: "blank", q: "We ___ have a yard. (don't)", options: ["don't"], a: "don't" },
        { type: "order", q: "Ordena: Alyssa doesn't have a garage.", words: ["Alyssa", "and", "Logan", "don't", "have", "a", "garage."], a: "Alyssa and Logan don't have a garage." }
      ]
    },
    {
      id: "u28-set4",
      title: "Set 4: Have Got Alternative",
      questions: [
        { type: "mc", q: "We have = We ___ got", options: ["have", "'ve"], a: "have" },
        { type: "mc", q: "She has = She's ___ got", options: ["got", "have"], a: "got" },
        { type: "blank", q: "I ___ got a dog. ('ve)", options: ["'ve"], a: "'ve" },
        { type: "mc", q: "He hasn't ___ a dog.", options: ["got", "have"], a: "got" },
        { type: "blank", q: "They ___ got a couch. (have)", options: ["have"], a: "have" },
        { type: "order", q: "Ordena: She has got a computer.", words: ["She", "has", "got", "a", "computer."], a: "She has got a computer." },
        { type: "mc", q: "'Have got' = British English. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "They don't ___ a couch.", options: ["have", "has"], a: "have" },
        { type: "blank", q: "He ___ got three sisters. (has)", options: ["has"], a: "has" },
        { type: "order", q: "Ordena: You haven't got a bike.", words: ["You", "haven't", "got", "a", "bike."], a: "You haven't got a bike." }
      ]
    },
    {
      id: "u28-set5",
      title: "Set 5: Listening/Object Matching",
      questions: [
        { type: "mc", q: "Maya has ___ (couch/dog)", options: ["couch", "dog"], a: "couch" },
        { type: "blank", q: "Ben has ___ (dog/car).", options: ["dog"], a: "dog" },
        { type: "mc", q: "Maya has bookcase? (T/F)", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Ben has ___ (car/TV).", options: ["car"], a: "car" },
        { type: "mc", q: "Maya has TV? Ben has TV?", options: ["Maya no, Ben yes", "Both yes"], a: "Maya no, Ben yes" },
        { type: "order", q: "Match: Maya couch, Ben dog.", words: ["Maya:", "couch", "Ben:", "dog"], a: "Maya: couch Ben: dog" },
        { type: "mc", q: "Who has daughter? (It)", options: ["True"], a: "True" },
        { type: "blank", q: "Maya has ___ (bookcase).", options: ["bookcase"], a: "bookcase" },
        { type: "mc", "q": "Ben has washing machine? (T/F)", options: ["True", "False"], a: "True" },
        { type: "order", q: "Maya TV? Ben car?", words: ["Maya:", "no", "TV", "Ben:", "car"], a: "Maya: no TV Ben: car" }
      ]
    },
    {
      id: "u28-set6",
      title: "Set 6: Create Sentences from Chart",
      questions: [
        { type: "blank", q: "I ___ a couch.", options: ["have"], a: "have" },
        { type: "mc", q: "She ___ chairs.", options: ["has some", "have some"], a: "has some" },
        { type: "blank", q: "We ___ a dining room.", options: ["have"], a: "have" },
        { type: "mc", q: "He ___n't have chairs.", options: ["doesn't", "don't"], a: "doesn't" },
        { type: "blank", q: "They ___ a couch.", options: ["have"], a: "have" },
        { type: "order", q: "Crea: She has / doesn't have / some chairs.", words: ["She", "has", "some", "chairs.", "She", "doesn't", "have", "chairs."], a: "She has some chairs. She doesn't have chairs." },
        { type: "mc", q: "You ___ a dining room.", options: ["have", "has"], a: "have" },
        { type: "blank", q: "It ___ a bathtub.", options: ["has"], a: "has" },
        { type: "mc", q: "We ___n't have a couch.", options: ["don't", "doesn't"], a: "don't" },
        // Modificado para ser una frase ordenable real
        { type: "order", q: "Crea: They don't have a dining room.", words: ["They", "don't", "have", "a", "dining", "room."], a: "They don't have a dining room." }
      ]
    },
    {
      id: "u28-set7",
      title: "Set 7: Error Correction",
      questions: [
        { type: "mc", q: "I has a house. (Fix)", options: ["I have a house", "I has house"], a: "I have a house" },
        { type: "blank", q: "She ___ have a dog. (doesn't)", options: ["doesn't"], a: "doesn't" },
        { type: "mc", q: "They has a car. Wrong?", options: ["True, they have", "False"], a: "True, they have" },
        { type: "order", q: "Corrige: He don't have a garage.", words: ["He", "doesn't", "have", "a", "garage."], a: "He doesn't have a garage." },
        { type: "blank", q: "We ___ have a yard. (don't)", options: ["don't"], a: "don't" },
        { type: "mc", q: "'It have a door.' Wrong = True.", options: ["True", "False"], a: "True" },
        { type: "mc", q: "You doesn't have a microwave. Fix?", options: ["You don't have", "You doesn't has"], a: "You don't have" },
        { type: "blank", q: "They ___ have a garage. (don't)", options: ["don't"], a: "don't" },
        { type: "order", q: "Corrige: She has a bathtub. She don't have.", words: ["She", "has", "a", "bathtub.", "She", "doesn't", "have."], a: "She has a bathtub. She doesn't have." },
        { type: "mc", q: "Have got: She ___ got. (hasn't)", options: ["True"], a: "True" }
      ]
    },
    {
      id: "u28-set8",
      title: "Set 8: House Ads Comprehension",
      questions: [
        { type: "mc", q: "Riverside: 3 bedrooms? (T/F)", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Riverside has ___ bathrooms. (two)", options: ["two"], a: "two" },
        { type: "mc", q: "Lake View has garage? No.", options: ["True", "False"], a: "False" },
        { type: "blank", q: "Stone Hill: ___ bedrooms, big kitchen. (four)", options: ["four"], a: "four" },
        { type: "mc", q: "Riverside: park next door. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Lake View: no garage, has ___ yard. (beautiful)", words: ["beautiful"], a: "beautiful" },
        { type: "mc", "q": "Stone Hill: bathtub AND shower. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "All have ___ furniture? (new)", options: ["new"], a: "new" },
        { type: "mc", "q": "Lake View: kitchen in basement. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Stone Hill: old part of ___, new furniture.", words: ["Bridgewater"], a: "Bridgewater" }
      ]
    },
    {
      id: "u28-set9",
      title: "Set 9: Mixed Have/Has Practice",
      questions: [
        // Convertido a MC para soportar 3 respuestas
        { type: "mc", q: "I ___ a garage / She ___ a yard / They ___ a car.", options: ["have / has / have", "has / have / has"], a: "have / has / have" },
        // Convertido a MC
        { type: "mc", q: "Don't have / Doesn't have. Correct?", options: ["I don't / She doesn't", "I doesn't / She don't"], a: "I don't / She doesn't" },
        // Convertido a MC
        { type: "mc", q: "Have got: I ___ got / She ___ got. ('ve/has)", options: ["'ve / has", "have / 's"], a: "'ve / has" },
        { type: "mc", q: "Riverside: 3 bed, 2 bath = has bathrooms.", options: ["True"], a: "True" },
        { type: "blank", q: "Lake View ___ garage. (doesn't have)", options: ["doesn't have"], a: "doesn't have" },
        { type: "order", q: "Mix: We don't have, we haven't got.", words: ["We", "don't", "have,", "we", "haven't", "got."], a: "We don't have, we haven't got." },
        { type: "mc", "q": "Stone Hill has bathtub + shower. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "You ___ three sisters. (have)", options: ["have"], a: "have" },
        { type: "mc", "q": "All correct: I have / She has / They don't have.", options: ["True"], a: "True" },
        // Convertido a frase ordenable real
        { type: "order", q: "Crea: He has a garage.", words: ["He", "has", "a", "garage."], a: "He has a garage." }
      ]
    },
    {
      id: "u28-set10",
      title: "Set 10: Full Challenge Review",
      questions: [
        { type: "mc", q: "Complete: I have / She has / They don't / Have got forms. All?", options: ["True"], a: "True" },
        // Convertido a MC para soportar 2 respuestas
        { type: "mc", q: "Riverside ___ 3 bedrooms, 2 bathrooms / Lake View ___ garage.", options: ["has / doesn't have", "have / don't have"], a: "has / doesn't have" },
        // Convertido a frase ordenable real
        { type: "order", q: "Crea: We haven't got a car.", words: ["We", "haven't", "got", "a", "car."], a: "We haven't got a car." },
        { type: "mc", "q": "Quick: It ___ a door. (has)", options: ["True"], a: "True" },
        { type: "blank", q: "Stone Hill ___ bathtub, shower, big kitchen.", options: ["has"], a: "has" },
        { type: "mc", "q": "'You has' wrong every time. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Challenge: House ad full description.", words: ["Riverside", "has", "3", "bedrooms,", "2", "bathrooms,", "beautiful", "park"], a: "Riverside has 3 bedrooms, 2 bathrooms, beautiful park" },
        // Convertido a MC para soportar 2 respuestas
        { type: "mc", q: "We ___ got a microwave / You ___ a bike. (have/have)", options: ["have / have", "has / has"], a: "have / have" },
        { type: "mc", "q": "All houses: Riverside park, Lake View yard, Stone Hill bathtub. True?", options: ["True"], a: "True" },
        { type: "order", q: "Ultimate: Complete possession paragraph.", words: ["I", "have", "a", "house", "with", "kitchen,", "She", "has", "a", "yard", "and", "garage."], a: "I have a house with kitchen, She has a yard and garage." }
      ]
    }
  ]
};
